var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTodayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "4 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7455 19.5269V5.16845C17.7455 4.68555 17.3589 4.29279 16.8839 4.29279H6.14764C5.67228 4.29279 5.28564 4.68555 5.28564 5.16845V19.5269C5.28564 20.0098 5.67228 20.4026 6.14764 20.4026H16.8839C17.3589 20.4026 17.7455 20.0098 17.7455 19.5269ZM16.8842 3C18.0985 3 19.0831 3.99417 19.0831 5.21272V19.4826C19.0831 20.7012 18.0985 21.6953 16.8842 21.6953H6.14796C4.93339 21.6953 3.94873 20.7012 3.94873 19.4826V5.21272C3.94873 3.9941 4.93339 3 6.14796 3H16.8842ZM6.41887 19.1457V8.50927H16.6133V19.1457H6.41887ZM6.98523 6.66286C6.67223 6.66286 6.41887 6.4182 6.41887 6.11593C6.41887 5.81367 6.67223 5.56901 6.98523 5.56901H11.5161C11.8291 5.56901 12.0824 5.81367 12.0824 6.11593C12.0824 6.4182 11.8291 6.66286 11.5161 6.66286H6.98523Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayIcon);
export default __webpack_public_path__ + "static/media/today-icon.795f69db71cdc256e7b6352317088a92.svg";
export { ForwardRef as ReactComponent };